import { useState } from "react";
import { Link } from "react-router-dom";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { MdOutlineMail } from "react-icons/md";
import Button from "@mui/joy/Button";
import { useAgent } from "@/Hooks/useAgent";
import ContactSalesModal from "../Utility/Modals/ContactSalesModal";
import ContactSupportModal from "../Utility/Modals/ContactSupportModal";
import { AgentAvatar } from "../Avatar/AgentAvatar";
import DarkModeSlider from "../DarkMode";

export default function HeaderButtons() {
	const agent = useAgent();

	const [contactSalesModalOpen, setContactSalesModalOpen] = useState(false);
	const [contactSupportModalOpen, setContactSupportModalOpen] = useState(false);

	const timestampSeconds = Math.floor(Date.now() / 1000);

	let daysLeftInTrialString = "";

	// Disabled for now.
	// const trialStarted = SettingsFunctions.getSettingValue(settings, "trialStarted");
	const trialStarted = null;

	if (trialStarted != null && trialStarted != "") {
		const daysLeftInTrial = Math.ceil(14 - (timestampSeconds - parseInt(trialStarted)) / 60 / 60 / 24);

		if (daysLeftInTrial != 1) {
			daysLeftInTrialString = daysLeftInTrial + " days left in trial.";
		} else {
			daysLeftInTrialString = daysLeftInTrial + " day left in trial.";
		}

		if (process.env.NODE_ENV == "development" || window.location.hostname == "localhost") {
			daysLeftInTrialString = "14 days left in trial.";
		}
	}

	return (
		<div className="flex pr-5 items-center">
			{/* <button><AiOutlineQuestionCircle /></button>*/}

			{/* <button onClick={() => navigate("/get-started")} style={{height: "2em", margin: "auto 1rem auto 0"}} className="btn-grey">GoDesk Setup (30%)</button>*/}

			<div className="flex items-center mr-5">
				{trialStarted != null ?
					<>
						<div className="mr-3">
							{daysLeftInTrialString}
						</div>

						<Button variant="outlined" color="neutral" onClick={() => setContactSalesModalOpen(true)} startDecorator={<MdOutlineMail />}>
							Contact Sales
						</Button>
						<ContactSalesModal isOpen={contactSalesModalOpen} closeModal={() => setContactSalesModalOpen(false)} />
					</>
					:
					<>
						<Button variant="outlined" color="neutral" onClick={() => setContactSupportModalOpen(true)} startDecorator={<MdOutlineMail />}>
							Contact support
						</Button>
						<ContactSupportModal isOpen={contactSupportModalOpen} closeModal={() => setContactSupportModalOpen(false)} />
					</>}
			</div>

			{process.env.NODE_ENV == "development" &&
				<>
					<Link to="/design"><Button size="sm" variant="outlined" color="neutral">D</Button></Link>
					<div className="m-2"><DarkModeSlider /></div>
				</>}

			{agent != null &&
				<OverlayTrigger rootClose trigger="click" placement="bottom-start" overlay={AgentPopover}>
					<button>
						<AgentAvatar agent={agent} widthPx={40} />
					</button>
				</OverlayTrigger>}
		</div>
	);
}

function AgentPopover(props: any) { // Props set to any so they can be passed to <Popover>. This may not be needed!
	return (
		<Popover id="popover-basic" className="mr-4"{...props}>
			<AgentPopoverContent />
		</Popover>
	);
}

function AgentPopoverContent() {
	const agent = useAgent();

	return (
		<>
			<Popover.Title className="font-bold">{agent?.name}</Popover.Title>
			<Popover.Content>
				{ agent == null ?
					<Link to="/login">Login</Link>
					:
					<>
						<div style={{ padding: "5px 0", borderBottom: "1px solid #ebebeb" }}><Link to={"/config/manage/agents/" + agent.id}>Profile settings</Link></div>
						<div style={{ padding: "5px 0" }}><Link to="/logout">Log out</Link></div>
					</>
				}
			</Popover.Content>
		</>
	);
}
